import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import { formatNumber } from "src/library/utils";

/**
 * This function returns a reusable formated column definition for numerical data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for numerical data
 */
export const numberColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "enableSorting" | "enableColumnFilter" | "cell" | "minSize" | "size" | "meta">>,
  props?: { disableNumberFormatting: boolean }
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    filterType: "string",
    header: column.header ? column.header.toString() : typeof accessor === "string" ? accessor : "",
    cell: column.cell ? column.cell : info => (
      <Text>
        {props?.disableNumberFormatting ? `${info.getValue()}` : formatNumber(info.getValue() as number)}
      </Text>
    ),
    enableSorting: column.enableSorting,
    enableColumnFilter: column.enableColumnFilter,
    minSize: column.minSize || 60,
    size: column.size,
    meta: {
      style: { align: "right" },
      filter: column.meta?.filter ? column.meta?.filter : {
        filterType: "string",
        minLength: 3
      }
    }

  } as DisplayColumnDef<TData>);
};
